import React, { useContext } from "react";
import { ToastsContainer, ToastsStore } from "react-toasts";
import ContextComponent from "../Context";

const Notification = () => {
  const context = useContext(ContextComponent);
  const createToast = (body, type) => {
    ToastsStore[type](body);
  };
  context.notification = createToast;

  return <ToastsContainer store={ToastsStore} />;
};

export default Notification;
